import type { FullCancellationCostsData, FullCancellationCostsState } from './types'

export const DEFAULT_FULL_CANCELLATION_COSTS_STATE: FullCancellationCostsState = {
  status: 'idle',
  isFreeCancellationAllowed: false,
  isCancellationWithCostsAllowed: false,
  freeCancellationLimitDate: '',
  amountPaid: null,
  amountToPay: null,
  cancellationCost: null,
}

export function isFullCancellationCostsDataValid(data: FullCancellationCostsData): boolean {
  return data.isFreeCancellationAllowed || data.isCancellationWithCostsAllowed
}
